import "./Phonetics.css";
export default function Phonetics(props) {
  function play() {
    let audio = new Audio(props.phonetic.audio);
    audio.play();
  }

  if (props.phonetic.audio) {
    return (
      <div className="Phonetics">
        {props.phonetic.text}{" "}
        <i className="fas fa-volume-up has-audio" onClick={play}></i>
      </div>
    );
  } else {
    return (
      <div className="Phonetics">
        {props.phonetic.text} <i className="fas fa-volume-up no-audio"></i>
      </div>
    );
  }
}
